export default __webpack_public_path__ + "static/fall2 (1)-188b6f313e235678de5b3a6ba7e1c12e.jpg";